import { useEffect, useState, useRef } from 'react';
import './Mandaatti.css';
import CryptoJS from 'crypto-js';
import { Container, Row, Col, Card, Form, Button } from 'react-bootstrap';
import Modal from 'react-modal';
import Logopikku from "./Pro2.jpg";
import { Navbar, Nav } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { VscFeedback, VscSignOut } from "react-icons/vsc";

const TRANSLATIONS = {
  fi: {
    languageSwitcherLabel: "Kieli:",
    tabs: { mandate: "Mandaatti", openProfile: "Avoin kuvaus" },
    confidentiality: "LUOTTAMUKSELLINEN",
    profileTitle: "TARKENNETTU HAKUPROFIILI",
    openProfileTitle: "AVOIN HAKUPROFIILI",
    jobDescriptionLabel: "Työnkuvaus",
    jobDescriptionPlaceholder: "Kopio työnkuvaus tähän",
    sectionTitles: {
      businessNeed: "1. LIIKETOIMINTATARVE",
      role: "2. TEHTÄVÄ",
      responsibilities: "3. VASTUUT",
      goals: "4. TAVOITTEET JA MITTARIT",
      experience: "5. KOKEMUS JA NÄYTÖT",
      skills: "6. Osaaminen",
      personality: "7. Persoona ja työskentelytapa",
      culture: "8. Toimintakulttuuri ja yrityksen arvot",
      appeal: "9. Houkuttelutekijät"
    },
    labels: {
      company: "YRITYS:",
      contactPerson: "YRITYKSEN YHTEYSHENKILÖ:",
      consultant: "Valitse konsultti:",
      consultantPlaceholder: "Valitse konsultti",
      interviewLanguage: "Valitse haastattelukieli:",
      interviewLanguagePlaceholder: "Valitse haastattelukieli",
      jobTitle: "HAETTAVA TEHTÄVÄ/TITTELI:",
      industry: "Toimiala",
      businessReason: "1.1 Mitkä ovat liiketoiminnalliset syyt rekrytoinnille?",
      companyStrategy: "1.2 Yrityksen strategia - ja mikä rooli valittavalla henkilöllä on strategian toteutumisessa?",
      oneYear: "1.3 Mikä yrityksessä on vuoden päästä paremmin, kun valittu henkilö on onnistunut työssään?",
      mainTasks: "2.1 Mitkä ovat henkilön keskeiset tehtävät?",
      reportTo: "2.2 Kenelle henkilö raportoi?",
      travelDays: "2.3 Työhön liittyvien pakollisten matkapäivien arvioitu määrä ja aihe/", // virkkeen loppu tiedostossa
      responsibilities: "3.1 Mitkä ovat henkilön keskeiset vastuualueet?",
      resultsNeeded: "4.1 Mitä valittavan henkilön on saatava konkreettisesti aikaiseksi:",
      first100Days: "4.1.1 Ensimmäisten 100 päivän aikana",
      firstYear: "4.1.2 Ensimmäisen vuoden aikana",
      years2To3: "4.1.3 Ensimmäisten 2–3 vuoden aikana",
      goalsAndMetrics: "4.2 Mitkä ovat konkreettiset tavoitteet ja mittarit, jotka todentavat henkilön/tehtävän tuottavuuden?",
      criticalSituations: "4.3 Kuvaile niitä tehtävän kriittisiä avaintilanteita, jotka ratkaisevasti voivat vaikuttaa tehtävässä menestymiseen tai epäonnistumiseen",
      experience: "5.1 Mitä kokemusta tehtävässä menestymisessä tarvitaan (5-6 vaihtoehtoa)?",
      achievements: "5.2 Mistä asioista ja onnistumisista henkilöllä tulee olla näyttöjä?",
      background: "5.3 Millainen tausta on sopivin tähän tehtävään (2-3 vaihtoehtoa)?",
      skills: "6.1 Mitä osaamista tehtävässä menestymisessä tarvitaan (5-6 vaihtoehtoa)?",
      personality: "7.1 Mitä luonteenpiirteitä / ominaisuuksia tehtävässä menestymisessä tarvitaan? Valikoi 3–5 keskeisintä tekijää, jotka uuden henkilön persoonassa vaikuttavat tehtävässä menestymiseen.",
      workLevels: "7.2 Työskentelyn tasot: strateginen (%), taktinen (%), operatiivinen (%).",
      workFocus: "7.3 Työskentelyn painoarvo: ennakointi ja suunnitelmallisuus (%), hetkessä reagointi (%).",
      teamDescription: "8.1 Kuvaile millaiseen työryhmään/työyhteisöön uusi henkilö sijoittuu?",
      cultureTraits: "8.2 Kuvaile mitkä ovat yrityksen toimintakulttuurissa näkyviä/hallitsevia piirteitä?",
      leadership: "8.3 Kuvaile yrityksen johtamiskäytäntöjä ja tapoja toimia.",
      values: "8.4 Mitkä ovat yrityksen arvot?",
      motivation: "Mitkä ovat ne onnistumisen, tuottavuuden ja jatkuvuuden kannalta tärkeimmät tekijät, joista henkilö tulee luultavimmin motivoitumaan työssään?",
      organizationAppeal: "9.1 Organisaatio (markkina-asema, tuotteiden ja/tai palveluiden laatu, asiakkaat, yritysvastuullisuus, maine)",
      jobAppeal: "9.2 Työ (työn mielekkyys, työn sisältö, työn ja vapaa-ajan tasapaino, myös jousto)",
      salary: "9.3 Kuukausiansiot + palkitseminen",
      people: "9.4 Ihmiset (kollegat, työntekijöiden maine sisä- ja ulkopuolella)",
      opportunities: "9.5 Mahdollisuudet (urapolut, kehitysmahdollisuudet, organisaation kasvu/kehitystavoitteet)",
      internalCandidates: "10. YRITYKSEN SISÄISET HAKIJAT",
      externalCandidates: "11. ULKOPUOLISET HAKIJAT",
      competitors: "12. YRITYKSEN KILPAILIJAT",
      prohibitedContacts: "13. KIELLETYT TAHOT, JOIHIN EI SAA OLLA YHTEYDESSÄ",
      finalInterviewParticipants: "14. FINAALIHAASTATTELUIHIN OSALLISTUVAT HENKILÖT",
      finalInterviewDate: "15. ALUSTAVA FINAALIHAASTATTELUPÄIVÄ",
      top5: "Edellytettävä kokemus/osaaminen:"
    },
    interviewLanguages: ["Suomi", "Ruotsi", "Englanti"],
    buttons: { submit: "Lähetä", close: "Sulje", cancel: "Peruuta" },
    notices: {
      attention: "Huom!",
      confirmationTitle: "Vahvistus",
      confirmationQuestion: "Haluatko varmasti lähettää tiedot?",
      readyTitle: "Lähetys valmis!",
      readyBody: "Tietojen lähetys onnistui.",
      readyNote: "Mandaatin luomisessa, käsittelyssä ja haastattelukysymyksien luonnissa kestää minuutin verran. ",
      loading: "Loading... Just a moment, please.",
      validationIntro: "Huom!"
    },
    errors: {
      company: "Yritys on pakollinen kenttä",
      contactPerson: "Yhteyshenkilö on pakollinen kenttä",
      consultant: "Konsultti on pakollinen valinta",
      language: "Haastattelukieli on pakollinen valinta",
      jobTitle: "Haettava tehtävä on pakollinen kenttä",
      industry: "Toimiala on pakollinen kenttä",
      top5: "Edellytettävä kokemus/osaamis-kenttä pakollinen"
    },
    consultantFallback: {
      none: "Konsultteja ei löytynyt",
      error: "Konsulttien lataamisessa tapahtui virhe"
    }
  },
  en: {
    languageSwitcherLabel: "Language:",
    tabs: { mandate: "Mandate", openProfile: "Open profile" },
    confidentiality: "CONFIDENTIAL",
    profileTitle: "DETAILED SEARCH PROFILE",
    openProfileTitle: "OPEN SEARCH PROFILE",
    jobDescriptionLabel: "Job description",
    jobDescriptionPlaceholder: "Paste the job description here",
    sectionTitles: {
      businessNeed: "1. BUSINESS NEED",
      role: "2. ROLE",
      responsibilities: "3. RESPONSIBILITIES",
      goals: "4. GOALS AND METRICS",
      experience: "5. EXPERIENCE",
      skills: "6. Skills",
      personality: "7. Personality and way of working",
      culture: "8. Operating culture and company values",
      appeal: "9. Attraction factors"
    },
    labels: {
      company: "COMPANY:",
      contactPerson: "COMPANY CONTACT PERSON:",
      consultant: "Choose consultant:",
      consultantPlaceholder: "Choose consultant",
      interviewLanguage: "Select interview language:",
      interviewLanguagePlaceholder: "Select interview language",
      jobTitle: "ROLE / TITLE:",
      industry: "Industry",
      businessReason: "1.1 What are the business reasons for the recruitment?",
      companyStrategy: "1.2 Company strategy - and what role will the selected person play in executing it?",
      oneYear: "1.3 What will be better in the company after a year when the selected person succeeds?",
      mainTasks: "2.1 What are the key tasks of the role?",
      reportTo: "2.2 Who does the person report to?",
      travelDays: "2.3 Estimated number and nature of mandatory travel days",
      responsibilities: "3.1 What are the person's key responsibility areas?",
      resultsNeeded: "4.1 What concrete results must the selected person deliver:",
      first100Days: "4.1.1 During the first 100 days",
      firstYear: "4.1.2 During the first year",
      years2To3: "4.1.3 During the first 2–3 years",
      goalsAndMetrics: "4.2 What are the concrete goals and metrics that demonstrate the productivity of the person/role?",
      criticalSituations: "4.3 Describe the critical key situations in the role that may decisively influence success or failure",
      experience: "5.1 What experience is needed to succeed in the role (5-6 options)?",
      achievements: "5.2 Which achievements should the person be able to demonstrate?",
      background: "5.3 What background best fits this role (2-3 options)?",
      skills: "6.1 What skills are required to succeed in the role (5-6 options)?",
      personality: "7.1 Which personality traits/qualities are needed? Choose the 3–5 most important factors that influence success.",
      workLevels: "7.2 Working levels: strategic (%), tactical (%), operational (%).",
      workFocus: "7.3 Work focus: anticipation and planning (%), reacting in the moment (%).",
      teamDescription: "8.1 Describe the team/community the new person will join",
      cultureTraits: "8.2 Describe the visible/dominant traits in the company culture",
      leadership: "8.3 Describe the company's leadership practices and ways of working.",
      values: "8.4 What are the company's values?",
      motivation: "What are the most important factors for success, productivity and continuity that will likely motivate the person?",
      organizationAppeal: "9.1 Organization (market position, quality of products/services, customers, responsibility, reputation)",
      jobAppeal: "9.2 Work (meaningfulness, content, work-life balance, flexibility)",
      salary: "9.3 Salary + incentives",
      people: "9.4 People (colleagues, employee reputation internally and externally)",
      opportunities: "9.5 Opportunities (career paths, development opportunities, organizational growth/development goals)",
      internalCandidates: "10. INTERNAL CANDIDATES",
      externalCandidates: "11. EXTERNAL CANDIDATES",
      competitors: "12. COMPANY COMPETITORS",
      prohibitedContacts: "13. PROHIBITED PARTIES TO AVOID CONTACT",
      finalInterviewParticipants: "14. FINAL INTERVIEW PARTICIPANTS",
      finalInterviewDate: "15. PRELIMINARY FINAL INTERVIEW DATE",
      top5: "Required experience/skills:"
    },
    interviewLanguages: ["Finnish", "Swedish", "English"],
    buttons: { submit: "Send", close: "Close", cancel: "Cancel" },
    notices: {
      attention: "Notice!",
      confirmationTitle: "Confirmation",
      confirmationQuestion: "Do you want to send the details?",
      readyTitle: "Submission ready!",
      readyBody: "The details were sent successfully.",
      readyNote: "Creating, processing and generating the mandate and interview questions takes about a minute.",
      loading: "Loading... Just a moment, please.",
      validationIntro: "Notice!"
    },
    errors: {
      company: "Company is a required field",
      contactPerson: "Contact person is a required field",
      consultant: "Consultant selection is required",
      language: "Interview language selection is required",
      jobTitle: "Role/title is a required field",
      industry: "Industry is a required field",
      top5: "Required experience/skills field is mandatory"
    },
    consultantFallback: {
      none: "No consultants found",
      error: "Error loading consultants"
    }
  },
  sv: {
    languageSwitcherLabel: "Språk:",
    tabs: { mandate: "Mandat", openProfile: "Öppen beskrivning" },
    confidentiality: "KONFIDENTIELLT",
    profileTitle: "FÖRDJUPAD SÖKPROFIL",
    openProfileTitle: "ÖPPEN SÖKPROFIL",
    jobDescriptionLabel: "Arbetsbeskrivning",
    jobDescriptionPlaceholder: "Klistra in arbetsbeskrivningen här",
    sectionTitles: {
      businessNeed: "1. AFFÄRSBEHOV",
      role: "2. UPPGIFT",
      responsibilities: "3. ANSVAR",
      goals: "4. MÅL OCH MÄTNING",
      experience: "5. ERFARENHET",
      skills: "6. Kompetens",
      personality: "7. Personlighet och arbetssätt",
      culture: "8. Organisationskultur och värderingar",
      appeal: "9. Attraktionsfaktorer"
    },
    labels: {
      company: "FÖRETAG:",
      contactPerson: "FÖRETAGETS KONTAKTPERSON:",
      consultant: "Välj konsult:",
      consultantPlaceholder: "Välj konsult",
      interviewLanguage: "Välj intervjuspråk:",
      interviewLanguagePlaceholder: "Välj intervjuspråk",
      jobTitle: "SÖKT ROLL/TITEL:",
      industry: "Bransch",
      businessReason: "1.1 Vilka är de affärsmässiga skälen till rekryteringen?",
      companyStrategy: "1.2 Företagets strategi - och vilken roll har den valda personen i genomförandet?",
      oneYear: "1.3 Vad är bättre i företaget om ett år när den valda personen har lyckats?",
      mainTasks: "2.1 Vilka är personens centrala uppgifter?",
      reportTo: "2.2 Vem rapporterar personen till?",
      travelDays: "2.3 Uppskattat antal obligatoriska resdagar och orsak/",
      responsibilities: "3.1 Vilka är personens huvudsakliga ansvarsområden?",
      resultsNeeded: "4.1 Vad behöver den valda personen konkret åstadkomma:",
      first100Days: "4.1.1 Under de första 100 dagarna",
      firstYear: "4.1.2 Under det första året",
      years2To3: "4.1.3 Under de första 2–3 åren",
      goalsAndMetrics: "4.2 Vilka är de konkreta målen och mätarna som visar personens/rollens produktivitet?",
      criticalSituations: "4.3 Beskriv de kritiska nyckelsituationer som kan påverka framgång eller misslyckande i rollen",
      experience: "5.1 Vilken erfarenhet behövs för att lyckas i rollen (5-6 alternativ)?",
      achievements: "5.2 Vilka saker och prestationer ska personen kunna visa upp?",
      background: "5.3 Vilken bakgrund passar bäst för denna roll (2-3 alternativ)?",
      skills: "6.1 Vilken kompetens behövs för att lyckas i rollen (5-6 alternativ)?",
      personality: "7.1 Vilka personlighetsdrag/egenskaper behövs? Välj de 3–5 viktigaste faktorerna som påverkar framgång.",
      workLevels: "7.2 Arbetsnivåer: strategisk (%), taktisk (%), operativ (%).",
      workFocus: "7.3 Arbetsfokus: framförhållning och planering (%), reaktion i stunden (%).",
      teamDescription: "8.1 Beskriv vilket team/arbetsgemenskap den nya personen kommer till",
      cultureTraits: "8.2 Beskriv de synliga/dominerande dragen i företagets kultur",
      leadership: "8.3 Beskriv företagets ledarskapspraxis och arbetssätt.",
      values: "8.4 Vilka är företagets värderingar?",
      motivation: "Vilka är de viktigaste faktorerna för framgång, produktivitet och kontinuitet som sannolikt motiverar personen?",
      organizationAppeal: "9.1 Organisation (marknadsposition, kvalitet på produkter/tjänster, kunder, ansvar, rykte)",
      jobAppeal: "9.2 Arbete (meningsfullhet, innehåll, balans mellan arbete och fritid, flexibilitet)",
      salary: "9.3 Månadslön + incitament",
      people: "9.4 Människor (kollegor, medarbetares rykte internt och externt)",
      opportunities: "9.5 Möjligheter (karriärvägar, utvecklingsmöjligheter, organisationens tillväxt/utvecklingsmål)",
      internalCandidates: "10. FÖRETAGETS INTERNA SÖKANDE",
      externalCandidates: "11. EXTERNA SÖKANDE",
      competitors: "12. FÖRETAGETS KONKURRENTER",
      prohibitedContacts: "13. FÖRBJUDNA PARTER ATT INTE KONTAKTAS",
      finalInterviewParticipants: "14. DELTAGARE I SLUTINTERVJUER",
      finalInterviewDate: "15. PRELIMINÄRT SLUTINTERVJUDATUM",
      top5: "Nödvändig erfarenhet/kompetens:"
    },
    interviewLanguages: ["Finska", "Svenska", "Engelska"],
    buttons: { submit: "Skicka", close: "Stäng", cancel: "Avbryt" },
    notices: {
      attention: "Observera!",
      confirmationTitle: "Bekräftelse",
      confirmationQuestion: "Vill du verkligen skicka uppgifterna?",
      readyTitle: "Utskick klart!",
      readyBody: "Uppgifterna skickades." ,
      readyNote: "Det tar cirka en minut att skapa, behandla och generera mandatet och intervjufrågorna.",
      loading: "Laddar... Ett ögonblick.",
      validationIntro: "Observera!"
    },
    errors: {
      company: "Företag är ett obligatoriskt fält",
      contactPerson: "Kontaktperson är ett obligatoriskt fält",
      consultant: "Val av konsult är obligatoriskt",
      language: "Val av intervjuspråk är obligatoriskt",
      jobTitle: "Sökt uppgift är ett obligatoriskt fält",
      industry: "Bransch är ett obligatoriskt fält",
      top5: "Fältet för erfarenhet/kompetens är obligatoriskt"
    },
    consultantFallback: {
      none: "Inga konsulter hittades",
      error: "Fel vid laddning av konsulter"
    }
  }
};


function Mandaatti() {

  const encryptionKey = process.env.REACT_APP_ENCRYPTION_KEY || 'kimi1234';

  const [formErrors, setFormErrors] = useState({});

    // FormData ja formGPT ennen salausta
   
  const [konsultit, setKonsultit] = useState([]);
  const [kielet, setKielet] = useState(["Suomi", "Ruotsi", "Englanti"]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [ready, setReady] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const submitInProgress = useRef(false);
  const [activeTab, setActiveTab] = useState('form1'); // Vaihdetaan lomakkeiden välillä
  const [nimi, setNimi] = useState('');
  const [group, setGroup] = useState('');
  const [latausKaynnissa, setLatausKaynnissa] = useState(false);
  const [language, setLanguage] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get('lang') || localStorage.getItem('mandateLanguagePreference') || 'fi';
  });
  const [sectionTitles, setSectionTitles] = useState(TRANSLATIONS.fi.sectionTitles);
  const [buttons, setButtons] = useState(TRANSLATIONS.fi.buttons);
  const [notices, setNotices] = useState(TRANSLATIONS.fi.notices);
  const [profileTitle, setProfileTitle] = useState(TRANSLATIONS.fi.profileTitle);
  const [openProfileTitle, setOpenProfileTitle] = useState(TRANSLATIONS.fi.openProfileTitle);
  const [jobDescriptionLabel, setJobDescriptionLabel] = useState(TRANSLATIONS.fi.jobDescriptionLabel);
  const [jobDescriptionPlaceholder, setJobDescriptionPlaceholder] = useState(TRANSLATIONS.fi.jobDescriptionPlaceholder);
  const [errorTexts, setErrorTexts] = useState(TRANSLATIONS.fi.errors);
  const [consultantFallback, setConsultantFallback] = useState(TRANSLATIONS.fi.consultantFallback);


  const location = useLocation();
  const navigate = useNavigate();

const fromButton = sessionStorage.getItem("fromButton") === "true";
const group2 = sessionStorage.getItem("group");


  useEffect(() => {
    console.log(group2);
    if (!fromButton) {
      navigate('/');
    }
  }, [fromButton, navigate]);

  const resolveLanguageKey = (value) => {
    const normalized = (value || '').toLowerCase();
    if (normalized.startsWith('sv') || normalized.includes('ruots') || normalized.includes('sven')) return 'sv';
    if (normalized.startsWith('en') || normalized.includes('engl')) return 'en';
    return 'fi';
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const paramLang = params.get('lang');
    if (paramLang) {
      setLanguage(paramLang);
    }
  }, [location.search]);

  useEffect(() => {
    const langKey = resolveLanguageKey(language);
    const translation = TRANSLATIONS[langKey];
    localStorage.setItem('mandateLanguagePreference', langKey);
    setKielet(translation.interviewLanguages);
    setSectionTitles(translation.sectionTitles);
    setButtons(translation.buttons);
    setNotices(translation.notices);
    setProfileTitle(translation.profileTitle);
    setOpenProfileTitle(translation.openProfileTitle);
    setJobDescriptionLabel(translation.jobDescriptionLabel);
    setJobDescriptionPlaceholder(translation.jobDescriptionPlaceholder);
    setErrorTexts(translation.errors);
    setConsultantFallback(translation.consultantFallback);
    setLuottamus(translation.confidentiality);
    setYritys(translation.labels.company);
    setYhteyshenkilo(translation.labels.contactPerson);
    setHaettavaTehtava(translation.labels.jobTitle);
    setToimiala(translation.labels.industry);
    setLiiketoiminnallisetSyyt(translation.labels.businessReason);
    setYrityksenStrategia(translation.labels.companyStrategy);
    setVuodenPaattaenParempi(translation.labels.oneYear);
    setKeskeisetTehtavat(translation.labels.mainTasks);
    setRaportointi(translation.labels.reportTo);
    setMatkapäivät(translation.labels.travelDays);
    setKeskeisetVastuualueet(translation.labels.responsibilities);
    setAikaiseksi(translation.labels.resultsNeeded);
    setEnsimmaiset100paivaa(translation.labels.first100Days);
    setEnsimmanenVuosi(translation.labels.firstYear);
    setEnsimmaiset2_3vuotta(translation.labels.years2To3);
    setTavoitteetJaMittarit(translation.labels.goalsAndMetrics);
    setAvainTilanteet(translation.labels.criticalSituations);
    setKokemus(translation.labels.experience);
    setOnnistumiset(translation.labels.achievements);
    setTausta(translation.labels.background);
    setOsaaminen(translation.labels.skills);
    setLuonteenpiirteet(translation.labels.personality);
    setTyoskentelynTasot(translation.labels.workLevels);
    setTyoskentelynPainoarvo(translation.labels.workFocus);
    setTyoryhma(translation.labels.teamDescription);
    setToimintakulttuuri(translation.labels.cultureTraits);
    setJohtamiskaytannot(translation.labels.leadership);
    setArvot(translation.labels.values);
    setMotivaatiotekijat(translation.labels.motivation);
    setOrganisaatio(translation.labels.organizationAppeal);
    setTyo(translation.labels.jobAppeal);
    setKuukausiansiot(translation.labels.salary);
    setIhmiset(translation.labels.people);
    setMahdollisuudet(translation.labels.opportunities);
    setSisaisetHakijat(translation.labels.internalCandidates);
    setUlkopuolisetHakijat(translation.labels.externalCandidates);
    setKilpailijat(translation.labels.competitors);
    setKielletytTahot(translation.labels.prohibitedContacts);
    setFinaalihaastattelijat(translation.labels.finalInterviewParticipants);
    setAlustavaFinaalihaastatteluPäivä(translation.labels.finalInterviewDate);
    setTop5Kriteerit(translation.labels.top5);
  }, [language]);



 

    // Avaa vahvistusmodaali
    const openModal = () => {
        setFormErrors({});
          const errors = {};

        if (!company) errors.company = errorTexts.company;
        if (!contactPerson) errors.contactPerson = errorTexts.contactPerson;
        if (!valittuKonsultti) errors.valittuKonsultti = errorTexts.consultant;
        if (!valittuKieli) errors.valittuKieli = errorTexts.language;
        if (!jobTitle) errors.jobTitle = errorTexts.jobTitle;
        if (!industry) errors.industry = errorTexts.industry;
        if (!top5Criteria) errors.top5Criteria = errorTexts.top5;
        if (Object.keys(errors).length > 0) {
          setFormErrors(errors);
          setIsModalOpen(true);
        }else{
          setIsModalOpen(true);
        }
    };
  
    // Sulje vahvistusmodaali
    const closeModal = () => {
      setIsModalOpen(false);
    };

      // Funktio aktiivisen välilehden vaihtamiseen
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };
  
  //Yritys
  const [company, setCompany] = useState("");
  //Konsultti
  const [valittuKonsultti, setValittuKonsultti] = useState('');
  //Kieli
  const [valittuKieli, setValittuKieli] = useState('');
  // YRITYKSEN YHTEYSHENKILÖ
  const [contactPerson, setContactPerson] = useState("");

  // HAETTAVA TEHTÄVÄ/TITTELI
  const [jobTitle, setJobTitle] = useState("");

  // Toimiala
  const [industry, setIndustry] = useState("");

  // 1. LIIKETOIMINTATARVE
  const [businessReason, setBusinessReason] = useState("");
  const [companyStrategy, setCompanyStrategy] = useState("");
  const [oneYear, setOneYear] = useState("");

  // 2. TEHTÄVÄ
  const [mainTasks, setMainTasks] = useState("");
  const [reportTo, setReportTo] = useState("");
  const [travelDays, setTravelDays] = useState("");

  // 3. VASTUUT
  const [responsibilities, setResponsibilities] = useState("");

  // 4. TAVOITTEET JA MITTARIT
  const [goals100Days, setGoals100Days] = useState("");
  const [goals1Year, setGoals1Year] = useState("");
  const [goals2To3Years, setGoals2To3Years] = useState("");
  const [performanceMetrics, setPerformanceMetrics] = useState("");
  const [criticalSituations, setCriticalSituations] = useState("");

  // 5. KOKEMUS JA NÄYTÖT
  const [experience, setExperience] = useState("");
  const [achievements, setAchievements] = useState("");
  const [background, setBackground] = useState("");

  // 6. OSAAMINEN
  const [skillsRequired, setSkillsRequired] = useState("");

  // 7. PERSOONA JA TYÖSKENTELYTAPA
  const [personalityTraits, setPersonalityTraits] = useState("");
  const [workLevel, setWorkLevel] = useState("");
  const [workFocus, setWorkFocus] = useState("");

  // 8. TOIMINTAKULTTUURI JA YRITYKSEN ARVOT
  const [teamDescription, setTeamDescription] = useState("");
  const [cultureTraits, setCultureTraits] = useState("");
  const [leadershipStyle, setLeadershipStyle] = useState("");
  const [companyValues, setCompanyValues] = useState("");

  // 9. HOUKUTTELUTEKIJÄT
  const [organizationAppeal, setOrganizationAppeal] = useState("");
  const [jobAppeal, setJobAppeal] = useState("");
  const [salaryAndIncentives, setSalaryAndIncentives] = useState("");
  const [peopleAppeal, setPeopleAppeal] = useState("");
  const [growthOpportunities, setGrowthOpportunities] = useState("");

  // 10. YRITYKSEN SISÄISET HAKIJAT
  const [internalCandidates, setInternalCandidates] = useState("");

  // 11. ULKOPUOLISET HAKIJAT
  const [externalCandidates, setExternalCandidates] = useState("");

  // 12. YRITYKSEN KILPAILIJAT
  const [competitors, setCompetitors] = useState("");

  // 13. KIELLETYT TAHOT, JOIHIN EI SAA OLLA YHTEYDESSÄ
  const [prohibitedContacts, setProhibitedContacts] = useState("");

  // 14. FINAALIHAASTATTELUIHIN OSALLISTUVAT HENKILÖT
  const [finalInterviewParticipants, setFinalInterviewParticipants] = useState("");

  // 15. ALUSTAVA FINAALIHAASTATTELUPÄIVÄ
  const [finalInterviewDate, setFinalInterviewDate] = useState("");

  // Top 5 kriteerit
  const [top5Criteria, setTop5Criteria] = useState("");

  // Avoin kuvaus
  const [avoin, setAvoin] = useState("");

  const [luottamus, setLuottamus] = useState("LUOTTAMUKSELLINEN");
  const [yritys, setYritys] = useState("YRITYS:");
  const [yhteyshenkilo, setYhteyshenkilo] = useState("YRITYKSEN YHTEYSHENKILÖ:");
  const [haettavaTehtava, setHaettavaTehtava] = useState("HAETTAVA TEHTÄVÄ/TITTELI:");
  const [toimiala, setToimiala] = useState("Toimiala");
  const [liiketoiminnallisetSyyt, setLiiketoiminnallisetSyyt] = useState("1.1 Mitkä ovat liiketoiminnalliset syyt rekrytoinnille?");
  const [yrityksenStrategia, setYrityksenStrategia] = useState("1.2 Yrityksen strategia - ja mikä rooli valittavalla henkilöllä on strategian toteutumisessa?");
  const [vuodenPaattaenParempi, setVuodenPaattaenParempi] = useState("1.3 Mikä yrityksessä on vuoden päästä paremmin, kun valittu henkilö on onnistunut työssään?");
  const [keskeisetTehtavat, setKeskeisetTehtavat] = useState("2.1 Mitkä ovat henkilön keskeiset tehtävät?");
  const [raportointi, setRaportointi] = useState("2.2 Kenelle henkilö raportoi?");
  const [matkapäivät, setMatkapäivät] = useState("2.3 Työhön liittyvien pakollisten matkapäivien arvioitu määrä ja aihe/v");
  const [keskeisetVastuualueet, setKeskeisetVastuualueet] = useState("3.1 Mitkä ovat henkilön keskeiset vastuualueet?");
  const [aikaiseksi, setAikaiseksi] =useState("4.1 Mitä valittavan henkilön on saatava konkreettisesti aikaiseksi:") 
  const [ensimmaiset100paivaa, setEnsimmaiset100paivaa] = useState("4.1.1 Ensimmäisten 100 päivän aikana");
  const [ensimmanenVuosi, setEnsimmanenVuosi] = useState("4.1.2 Ensimmäisen vuoden aikana");
  const [ensimmaiset2_3vuotta, setEnsimmaiset2_3vuotta] = useState("4.1.3 Ensimmäisten 2–3 vuoden aikana");
  const [tavoitteetJaMittarit, setTavoitteetJaMittarit] = useState("4.2 Mitkä ovat konkreettiset tavoitteet ja mittarit, jotka todentavat henkilön/tehtävän tuottavuuden?");
  const [avainTilanteet, setAvainTilanteet] = useState("4.3 Kuvaile niitä tehtävän kriittisiä avaintilanteita, jotka ratkaisevasti voivat vaikuttaa tehtävässä menestymiseen tai epäonnistumiseen");
  const [kokemus, setKokemus] = useState("5.1 Mitä kokemusta tehtävässä menestymisessä tarvitaan (5-6 vaihtoehtoa)?");
  const [onnistumiset, setOnnistumiset] = useState("5.2 Mistä asioista ja onnistumisista henkilöllä tulee olla näyttöjä?");
  const [tausta, setTausta] = useState("5.3 Millainen tausta on sopivin tähän tehtävään (2-3 vaihtoehtoa)?");
  const [osaaminen, setOsaaminen] = useState("6.1 Mitä osaamista tehtävässä menestymisessä tarvitaan (5-6 vaihtoehtoa)?");
  const [luonteenpiirteet, setLuonteenpiirteet] = useState("7.1 Mitä luonteenpiirteitä / ominaisuuksia tehtävässä menestymisessä tarvitaan? Valikoi 3–5 keskeisintä tekijää, jotka uuden henkilön persoonassa vaikuttavat tehtävässä menestymiseen.");
  const [tyoskentelynTasot, setTyoskentelynTasot] = useState("7.2 Työskentelyn tasot: strateginen (%), taktinen (%), operatiivinen (%).");
  const [tyoskentelynPainoarvo, setTyoskentelynPainoarvo] = useState("7.3 Työskentelyn painoarvo: ennakointi ja suunnitelmallisuus (%), hetkessä reagointi (%).");
  const [tyoryhma, setTyoryhma] = useState("8.1 Kuvaile millaiseen työryhmään/työyhteisöön uusi henkilö sijoittuu?");
  const [toimintakulttuuri, setToimintakulttuuri] = useState("8.2 Kuvaile mitkä ovat yrityksen toimintakulttuurissa näkyviä/hallitsevia piirteitä?");
  const [johtamiskaytannot, setJohtamiskaytannot] = useState("8.3 Kuvaile yrityksen johtamiskäytäntöjä ja tapoja toimia.");
  const [arvot, setArvot] = useState("8.4 Mitkä ovat yrityksen arvot?");
  const [motivaatiotekijat, setMotivaatiotekijat] = useState("Mitkä ovat ne onnistumisen, tuottavuuden ja jatkuvuuden kannalta tärkeimmät tekijät, joista henkilö tulee luultavimmin motivoitumaan työssään?");
  const [organisaatio, setOrganisaatio] = useState("9.1 Organisaatio (markkina-asema, tuotteiden ja/tai palveluiden laatu, asiakkaat, yritysvastuullisuus, maine)");
  const [tyo, setTyo] = useState("9.2 Työ (työn mielekkyys, työn sisältö, työn ja vapaa-ajan tasapaino, myös jousto)");
  const [kuukausiansiot, setKuukausiansiot] = useState("9.3 Kuukausiansiot + palkitseminen");
  const [ihmiset, setIhmiset] = useState("9.4 Ihmiset (kollegat, työntekijöiden maine sisä- ja ulkopuolella)");
  const [mahdollisuudet, setMahdollisuudet] = useState("9.5 Mahdollisuudet (urapolut, kehitysmahdollisuudet, organisaation kasvu/kehitystavoitteet)");
  const [sisaisetHakijat, setSisaisetHakijat] = useState("10. YRITYKSEN SISÄISET HAKIJAT");
  const [ulkopuolisetHakijat, setUlkopuolisetHakijat] = useState("11. ULKOPUOLISET HAKIJAT");
  const [kilpailijat, setKilpailijat] = useState("12. YRITYKSEN KILPAILIJAT");
  const [kielletytTahot, setKielletytTahot] = useState("13. KIELLETYT TAHOT, JOIHIN EI SAA OLLA YHTEYDESSÄ");
  const [finaalihaastattelijat, setFinaalihaastattelijat] = useState("14. FINAALIHAASTATTELUIHIN OSALLISTUVAT HENKILÖT");
  const [alustavaFinaalihaastatteluPäivä, setAlustavaFinaalihaastatteluPäivä] = useState("15. ALUSTAVA FINAALIHAASTATTELUPÄIVÄ");
  const [top5Kriteerit, setTop5Kriteerit] = useState("Edellytettävä kokemus/osaaminen:");

  

  const handleInputChange = (e, setState) => {
    const text = e.target.value;
    setState(text);
  };
  
  // Päivitetty handleKeyDown ilman pallukoiden lisäystä tai poistoa
  const handleKeyDown = (e, setState) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      // Lisää uusi rivi ilman pallukkaa
      setState(prev => {
        const newValue = `${prev}\n`;
        setTimeout(() => {
          const textArea = e.target;
          textArea.style.height = "auto"; // Nollaa korkeus
          textArea.style.height = `${textArea.scrollHeight}px`; // Aseta korkeus sisällön mukaan
        }, 0);
        return newValue;
      });
    } else if (e.key === 'Backspace') {
      // Jos halutaan säilyttää normaali rivin poistotoiminto, ei tarvitse lisätoimintoja
    }
  };



  useEffect(() => {
    if (group === "") {
        const currentUrl = window.location.href;
        const parsedUrl = new URL(currentUrl);
        const pathParts = parsedUrl.pathname.split('/');
        if (pathParts.length > 1) {
            setGroup(pathParts[1]); // tallennetaan "prosource" tilaan
        }
    }
  
}, [group]);

  const confirmSubmit = async () => {
      if (submitInProgress.current) return;
      submitInProgress.current = true;

      let formData = {};
      let formGPT = {};
    

      setIsSending(true);
      setSubmitError('');
      
      if(activeTab =="form1"){



        formData ={
          company,                      // Yritys
          valittuKonsultti,             // Konsultti
          valittuKieli,                 // Kieli
          contactPerson,                // Yrityksen yhteyshenkilö
          
          jobTitle,                     // Haettava tehtävä/titteli
          industry,                     // Haettava tehtävä/titteli
          
          businessReason,               // Liiketoimintatarve
          companyStrategy,              // Yrityksen strategia
          oneYear,                      // Ensimmäisen vuoden tavoitteet
          
          mainTasks,                    // Tehtävä
          reportTo,                     // Raportointi
          travelDays,                   // Matkapäivät
          
          responsibilities,             // Vastuut
          
          goals100Days,                 // Tavoitteet 100 päivää
          goals1Year,                   // Tavoitteet 1 vuosi
          goals2To3Years,               // Tavoitteet 2-3 vuotta
          performanceMetrics,           // Suorituskykymittarit
          criticalSituations,           // Kritiittiset tilanteet
          
          experience,                   // Kokemus ja näytöt
          achievements,                 // Saavutukset
          background,                   // Tausta
          
          skillsRequired,               // Osaamistarpeet
          
          personalityTraits,            // Persoonallisuus ja työskentelytapa
          workLevel,                    // Työtaso
          workFocus,                    // Työskentelyn painopisteet
          
          teamDescription,              // Tiimin kuvaus
          cultureTraits,                // Toimintakulttuuri
          leadershipStyle,              // Johtamistyylit
          companyValues,                // Yrityksen arvot
          
          organizationAppeal,           // Houkuttelutekijät - Organisaation vetovoima
          jobAppeal,                    // Houkuttelutekijät - Tehtävän vetovoima
          salaryAndIncentives,          // Palkka ja kannustimet
          peopleAppeal,                 // Houkuttelutekijät - Ihmiset
          growthOpportunities,          // Kasvumahdollisuudet
          
          internalCandidates,           // Sisäiset hakijat
          externalCandidates,           // Ulkopuoliset hakijat
          
          competitors,                  // Kilpailijat
          
          prohibitedContacts,           // Kielletut tahot
          finalInterviewParticipants,   // Finaalihaastatteluihin osallistuvat
          finalInterviewDate,           // Alustava finaalihaastattelupäivä
          
          top5Criteria,                  // Top 5 kriteerit
        };

        formGPT ={
          "Yritys": company,
          "Konsultti": valittuKonsultti,
          "Kieli": valittuKieli,
          
          "Haettava tehtävä/titteli": jobTitle,
          "Toimiala": industry,
          
          "Liiketoimintatarve": businessReason,
          "Yrityksen strategia": companyStrategy,
          "Ensimmäisen vuoden tavoitteet": oneYear,
          
          "Tehtävä": mainTasks,
          "Matkapäivät": travelDays,
          
          "Vastuut": responsibilities,
          
          "Tavoitteet 100 päivää": goals100Days,
          "Tavoitteet 1 vuosi": goals1Year,
          "Tavoitteet 2-3 vuotta": goals2To3Years,
          "Suorituskykymittarit": performanceMetrics,
          "Kritiittiset tilanteet": criticalSituations,
          
          "Kokemus ja näytöt": experience,
          "Saavutukset": achievements,
          "Tausta": background,
          
          "Osaamistarpeet": skillsRequired,
          
          "Persoonallisuus ja työskentelytapa": personalityTraits,
          "Työtaso": workLevel,
          "Työskentelyn painopisteet": workFocus,

          "Tiimin kuvaus": teamDescription,
          "Toimintakulttuuri": cultureTraits,
          "Johtamistyylit": leadershipStyle,
          "Yrityksen arvot": companyValues,
          "Organisaation vetovoima": organizationAppeal,
          "Työn vetovoima": jobAppeal,
          "Palkka ja kannustimet": salaryAndIncentives,
          "Ihmiset": peopleAppeal,
          "Kasvumahdollisuudet": growthOpportunities,

          "Top 5 kriteerit": top5Criteria
        };
      }else{
        formData ={
          company,                      // Yritys
          valittuKonsultti,             // Konsultti
          valittuKieli,                 // Kieli
          contactPerson,                // Yrityksen yhteyshenkilö
          
          jobTitle,                     // Haettava tehtävä/titteli
          industry,                     // Haettava tehtävä/titteli
          top5Criteria,
          avoin
        };

        formGPT={
          "Yritys": company,
          "Konsultti": valittuKonsultti,
          "Kieli": valittuKieli,
          
          "Haettava tehtävä/titteli": jobTitle,
          "Toimiala": industry,
          "top kriteerit":top5Criteria,
          "Avoin työnkuvaus": avoin
        };

      }
    
    
      const encryptedFormData = CryptoJS.AES.encrypt(JSON.stringify(formData), encryptionKey).toString();
      const encryptedFormGPT = CryptoJS.AES.encrypt(JSON.stringify(formGPT), encryptionKey).toString();
  
      
      setLatausKaynnissa(true);

      try {
        const response = await fetch('https://us-central1-tcgai-c07e9.cloudfunctions.net/api/saveMandate', {
      //fetch('http://localhost:5001/tcgai-c07e9/us-central1/api/saveMandate', {

      
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ 
              data: encryptedFormData, 
              nimi: valittuKonsultti, 
              group: group2, 
              gpt: encryptedFormGPT ,
              lomake: activeTab
          })
        });
        const text = await response.text();
        if (!response.ok || text !== "valmis") {
          throw new Error(text || `Mandate creation failed (${response.status})`);
        }
        setReady(true);
      } catch (error) {
        console.error('Mandate creation failed:', error);
        setSubmitError(error.message || 'Mandate creation failed. Please try again.');
      } finally {
        submitInProgress.current = false;
        setLatausKaynnissa(false);
        setIsSending(false);
      }
         
  }

  const haeKonsultit = async () => {
    setLatausKaynnissa(true);
    try {
      const response = await fetch('https://us-central1-tcgai-c07e9.cloudfunctions.net/api/loadConsults', {
      //const response = await fetch('http://localhost:5001/tcgai-c07e9/us-central1/api/loadConsults', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ name: group2 })
      });
      
      const data = await response.json();
      if (data && data.length > 0) {
        setKonsultit(data);

      } else {
        setKonsultit([consultantFallback.none]);
      }
    } catch (error) {
      console.error(error);
      setKonsultit([consultantFallback.error]);
    } finally {
      setLatausKaynnissa(false);
    }
   
  };

  useEffect(() => {
    if (nimi !== "") {
      haeKonsultit();
    }
  }, [nimi]);

  useEffect(() => {
    if (nimi === "") {
      const currentUrl = window.location.href;
      const parsedUrl = new URL(currentUrl);
      const pathParts = parsedUrl.pathname.split('/');
      if (pathParts.length > 1) {
        setNimi(pathParts[1]);
      }
    }
   
  }, [nimi]);
   //nappi josta pois
    function homepage(){
         navigate('/dashboard');
      }

  const currentTranslation = TRANSLATIONS[resolveLanguageKey(language)];

  return (
    <div className="mandaatti-container" >
      <div className="LanguageSwitcher" style={{ display: 'flex', justifyContent: 'flex-end', marginRight: '5vw' }}>
        <label htmlFor="language-select" style={{ marginRight: '1vw' }}>{currentTranslation.languageSwitcherLabel}</label>
        <select
          id="language-select"
          value={language}
          onChange={(event) => setLanguage(event.target.value)}
          aria-label={currentTranslation.languageSwitcherLabel}
        >
          <option value="fi">Suomi</option>
          <option value="en">English</option>
          <option value="sv">Svenska</option>
        </select>
      </div>
      <div className="TopNavIcon">
                    <Nav.Link onClick={() => homepage()} className="d-none d-md-block">
                        <VscSignOut style={{ fontSize: "1.9em" }} />
                    </Nav.Link>
                </div>
      {/* Välilehdet */}
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '3vh' }}>
        <button
          onClick={() => handleTabChange('form1')}
          style={{
            padding: '1vh 2vh',
            backgroundColor: activeTab === 'form1' ? '#007bff' : '#f0f0f0',
            color: activeTab === 'form1' ? '#fff' : '#000',
            border: 'none',
            cursor: 'pointer',
            marginRight: '1vh'
          }}
          aria-label={currentTranslation.tabs.mandate}
          title={currentTranslation.tabs.mandate}
        >
          {currentTranslation.tabs.mandate}
        </button>
        <button
          onClick={() => handleTabChange('form2')}
          style={{
            padding: '1vh 2vh',
            backgroundColor: activeTab === 'form2' ? '#007bff' : '#f0f0f0',
            color: activeTab === 'form2' ? '#fff' : '#000',
            border: 'none',
            cursor: 'pointer'
          }}
          aria-label={currentTranslation.tabs.openProfile}
          title={currentTranslation.tabs.openProfile}
        >
          {currentTranslation.tabs.openProfile}
        </button>
      </div>
      <div className="form-group" style={{ marginTop: "0vh", marginBottom: "5vh" }}>
      <label style={{ textDecoration: "underline" }}>{luottamus}</label>
      </div>

      {activeTab === 'form1' && ( <div>
        <h2>{profileTitle}</h2>

        <div className="form-group">
          <label>{yritys}</label>
          <input
            type="text"
            value={company}
            onChange={(e) => setCompany(e.target.value)}
          />
        </div>

      <div className="form-group">
        <label>{yhteyshenkilo}</label>
        <input
          type="text"
          value={contactPerson}
          onChange={(e) => setContactPerson(e.target.value)}
        />
      </div>

      <div className="form-group">
        <label>{currentTranslation.labels.consultant}</label>
        <select value={valittuKonsultti} onChange={(e) => setValittuKonsultti(e.target.value)}>
          <option value="">{latausKaynnissa ? notices.loading : currentTranslation.labels.consultantPlaceholder}</option>
          {!latausKaynnissa && konsultit.map((konsultti, index) => (
            <option key={index} value={konsultti}>{konsultti}</option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label>{currentTranslation.labels.interviewLanguage}</label>
        <select value={valittuKieli} onChange={(e) => setValittuKieli(e.target.value)}>
          <option value="">{currentTranslation.labels.interviewLanguagePlaceholder}</option>
          { kielet.map((kieli, index) => (
            <option key={index} value={kieli}>{kieli}</option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label>{haettavaTehtava}</label>
        <input
          type="text"
          value={jobTitle}
          onChange={(e) => setJobTitle(e.target.value)}
        />
      </div>

      <div className="form-group">
        <label>{toimiala}</label>
        <input
          type="text"
          value={industry}
          onChange={(e) => setIndustry(e.target.value)}
        />
      </div>
      <div className="form-group" style={{ marginTop: "5vh" }}>
        <label>{sectionTitles.businessNeed}</label>
      </div>

      <div className="form-group" style={{ marginTop: "5vh" }}>
        <label>{liiketoiminnallisetSyyt}</label>
      </div>

      <textarea
      value={businessReason}
      onChange={(e) => {
        handleInputChange(e, setBusinessReason);
        e.target.style.height = "auto";
        e.target.style.height = e.target.value.trim() !== "" ? `${e.target.scrollHeight}px` : '1vh';
      }}
      onKeyDown={(e) => handleKeyDown(e, setBusinessReason, businessReason)}
      className="form-control"
      style={{ 
        overflow: 'hidden', 
        height: '1vh', 
        marginBottom: "1vh"
      }} 
      />

  <div className="form-group">
    <label>{yrityksenStrategia}</label>
    <textarea
      value={companyStrategy}
      onChange={(e) => {
        handleInputChange(e, setCompanyStrategy);
        e.target.style.height = "auto";
        e.target.style.height = e.target.value.trim() !== "" ? `${e.target.scrollHeight}px` : '1vh';
      }}
      onKeyDown={(e) => handleKeyDown(e, setCompanyStrategy, companyStrategy)}
      className="form-control"
      style={{
        overflow: 'hidden',
        height: '1vh', // Alkuperäinen korkeus
        marginBottom: "1vh"
      }}
    />
  </div>

<div className="form-group">
  <label>{vuodenPaattaenParempi}</label>
  <textarea
    value={oneYear}
    onChange={(e) => {
      handleInputChange(e, setOneYear);
      e.target.style.height = "auto";
      e.target.style.height = e.target.value.trim() !== "" ? `${e.target.scrollHeight}px` : '1vh';
    }}
    onKeyDown={(e) => handleKeyDown(e, setOneYear, oneYear)}
    className="form-control"
    style={{
      overflow: 'hidden',
      height: '1vh', // Alkuperäinen korkeus
      marginBottom: "1vh"
    }}
  />
</div>

<div className="form-group" style={{ marginTop: "5vh" }}>
  <label>{sectionTitles.role}</label>
</div>

<div className="form-group">
  <label>{keskeisetTehtavat}</label>
  <textarea
    value={mainTasks}
    onChange={(e) => {
      setMainTasks(e.target.value);
      e.target.style.height = "auto";
      e.target.style.height = e.target.value.trim() !== "" ? `${e.target.scrollHeight}px` : '1vh';
    }}
    onKeyDown={(e) => handleKeyDown(e, setMainTasks, mainTasks)}
    className="form-control"
    style={{
      overflow: 'hidden',
      height: '1vh', // Alkuperäinen korkeus
      marginBottom: "1vh"
    }}
  />
</div>

<div className="form-group">
  <label>{raportointi}</label>
  <textarea
    value={reportTo}
    onChange={(e) => {
      setReportTo(e.target.value);
      e.target.style.height = "auto";
      e.target.style.height = e.target.value.trim() !== "" ? `${e.target.scrollHeight}px` : '1vh';
    }}
    onKeyDown={(e) => handleKeyDown(e, setReportTo, reportTo)}
    className="form-control"
    style={{
      overflow: 'hidden',
      height: '1vh', // Alkuperäinen korkeus
      marginBottom: "1vh"
    }}
  />
</div>

<div className="form-group">
  <label>{matkapäivät}</label>
  <textarea
    value={travelDays}
    onChange={(e) => {
      setTravelDays(e.target.value);
      e.target.style.height = "auto";
      e.target.style.height = e.target.value.trim() !== "" ? `${e.target.scrollHeight}px` : '1vh';
    }}
    onKeyDown={(e) => handleKeyDown(e, setTravelDays, travelDays)}
    className="form-control"
    style={{
      overflow: 'hidden',
      height: '1vh', // Alkuperäinen korkeus
      marginBottom: "1vh"
    }}
  />
</div>

<div className="form-group" style={{ marginTop: "5vh" }}>
  <label>{sectionTitles.responsibilities}</label>
</div>

<div className="form-group">
  <label>{keskeisetVastuualueet}</label>
  <textarea
    value={responsibilities}
    onChange={(e) => {
      setResponsibilities(e.target.value);
      e.target.style.height = "auto";
      e.target.style.height = e.target.value.trim() !== "" ? `${e.target.scrollHeight}px` : '1vh';
    }}
    onKeyDown={(e) => handleKeyDown(e, setResponsibilities, responsibilities)}
    className="form-control"
    style={{
      overflow: 'hidden',
      height: '1vh', // Alkuperäinen korkeus
      marginBottom: "1vh"
    }}
  />
</div>

<div className="form-group" style={{ marginTop: "5vh" }}>
  <label>{sectionTitles.goals}</label>
</div>

<div className="form-group">
  <label>{aikaiseksi}</label>
  <label>{ensimmaiset100paivaa}</label>
  <textarea
    value={goals100Days}
    onChange={(e) => {
      setGoals100Days(e.target.value);
      e.target.style.height = "auto";
      e.target.style.height = e.target.value.trim() !== "" ? `${e.target.scrollHeight}px` : '1vh';
    }}
    onKeyDown={(e) => handleKeyDown(e, setGoals100Days, goals100Days)}
    className="form-control"
    style={{
      overflow: 'hidden',
      height: '1vh', // Alkuperäinen korkeus
      marginBottom: "1vh"
    }}
  />
</div>

<div className="form-group">
  <label>{ensimmanenVuosi}</label>
  <textarea
    value={goals1Year}
    onChange={(e) => {
      setGoals1Year(e.target.value);
      e.target.style.height = "auto";
      e.target.style.height = e.target.value.trim() !== "" ? `${e.target.scrollHeight}px` : '1vh';
    }}
    onKeyDown={(e) => handleKeyDown(e, setGoals1Year, goals1Year)}
    className="form-control"
    style={{
      overflow: 'hidden',
      height: '1vh', // Alkuperäinen korkeus
      marginBottom: "1vh"
    }}
  />
</div>

<div className="form-group">
  <label>{ensimmaiset2_3vuotta}</label>
  <textarea
    value={goals2To3Years}
    onChange={(e) => {
      setGoals2To3Years(e.target.value);
      e.target.style.height = "auto";
      e.target.style.height = e.target.value.trim() !== "" ? `${e.target.scrollHeight}px` : '1vh';
    }}
    onKeyDown={(e) => handleKeyDown(e, setGoals2To3Years, goals2To3Years)}
    className="form-control"
    style={{
      overflow: 'hidden',
      height: '1vh', // Alkuperäinen korkeus
      marginBottom: "1vh"
    }}
  />
</div>


<div className="form-group">
  <label>{tavoitteetJaMittarit}</label>
  <textarea
    value={performanceMetrics}
    onChange={(e) => {
      setPerformanceMetrics(e.target.value);
      e.target.style.height = "auto";
      e.target.style.height = e.target.value.trim() !== "" ? `${e.target.scrollHeight}px` : '1vh';
    }}
    onKeyDown={(e) => handleKeyDown(e, setPerformanceMetrics, performanceMetrics)}
    className="form-control"
    style={{
      overflow: 'hidden',
      height: '1vh', // Alkuperäinen korkeus
      marginBottom: "1vh"
    }}
  />
</div>

<div className="form-group">
  <label>{avainTilanteet}</label>
  <textarea
    value={criticalSituations}
    onChange={(e) => {
      setCriticalSituations(e.target.value);
      e.target.style.height = "auto";
      e.target.style.height = e.target.value.trim() !== "" ? `${e.target.scrollHeight}px` : '1vh';
    }}
    onKeyDown={(e) => handleKeyDown(e, setCriticalSituations, criticalSituations)}
    className="form-control"
    style={{
      overflow: 'hidden',
      height: '1vh', // Alkuperäinen korkeus
      marginBottom: "1vh"
    }}
  />
</div>

<div className="form-group" style={{ marginTop: "5vh" }}>
  <label>{sectionTitles.experience}</label>
</div>

<div className="form-group">
  <label>{kokemus}</label>
  <textarea
    value={experience}
    onChange={(e) => {
      setExperience(e.target.value);
      e.target.style.height = "auto";
      e.target.style.height = e.target.value.trim() !== "" ? `${e.target.scrollHeight}px` : '1vh';
    }}
    onKeyDown={(e) => handleKeyDown(e, setExperience, experience)}
    className="form-control"
    style={{
      overflow: 'hidden',
      height: '1vh', // Alkuperäinen korkeus
      marginBottom: "1vh"
    }}
  />
</div>

<div className="form-group">
  <label>{onnistumiset}</label>
  <textarea
    value={achievements}
    onChange={(e) => {
      setAchievements(e.target.value);
      e.target.style.height = "auto";
      e.target.style.height = e.target.value.trim() !== "" ? `${e.target.scrollHeight}px` : '1vh';
    }}
    onKeyDown={(e) => handleKeyDown(e, setAchievements, achievements)}
    className="form-control"
    style={{
      overflow: 'hidden',
      height: '1vh', // Alkuperäinen korkeus
      marginBottom: "1vh"
    }}
  />
</div>

<div className="form-group">
  <label>{tausta}</label>
  <textarea
    value={background}
    onChange={(e) => {
      setBackground(e.target.value);
      e.target.style.height = "auto";
      e.target.style.height = e.target.value.trim() !== "" ? `${e.target.scrollHeight}px` : '1vh';
    }}
    onKeyDown={(e) => handleKeyDown(e, setBackground, background)}
    className="form-control"
    style={{
      overflow: 'hidden',
      height: '1vh', // Alkuperäinen korkeus
      marginBottom: "1vh"
    }}
  />
</div>

<div className="form-group" style={{ marginTop: "5vh" }}>
  <label>{sectionTitles.skills}</label>
</div>

<div className="form-group">
  <label>{osaaminen}</label>
  <textarea
    value={skillsRequired}
    onChange={(e) => {
      setSkillsRequired(e.target.value);
      e.target.style.height = "auto";
      e.target.style.height = e.target.value.trim() !== "" ? `${e.target.scrollHeight}px` : '1vh';
    }}
    onKeyDown={(e) => handleKeyDown(e, setSkillsRequired, skillsRequired)}
    className="form-control"
    style={{
      overflow: 'hidden',
      height: '1vh', // Alkuperäinen korkeus
      marginBottom: "1vh"
    }}
  />
</div>

<div className="form-group" style={{ marginTop: "5vh" }}>
  <label>{sectionTitles.personality}</label>
</div>

<div className="form-group">
  <label>{luonteenpiirteet}</label>
  <textarea
    value={personalityTraits}
    onChange={(e) => {
      setPersonalityTraits(e.target.value);
      e.target.style.height = "auto";
      e.target.style.height = e.target.value.trim() !== "" ? `${e.target.scrollHeight}px` : '1vh';
    }}
    onKeyDown={(e) => handleKeyDown(e, setPersonalityTraits, personalityTraits)}
    className="form-control"
    style={{
      overflow: 'hidden',
      height: '1vh', // Alkuperäinen korkeus
      marginBottom: "1vh"
    }}
  />
</div>

<div className="form-group">
  <label>{tyoskentelynTasot}</label>
  <textarea
    value={workLevel}
    onChange={(e) => {
      setWorkLevel(e.target.value);
      e.target.style.height = "auto";
      e.target.style.height = e.target.value.trim() !== "" ? `${e.target.scrollHeight}px` : '1vh';
    }}
    onKeyDown={(e) => handleKeyDown(e, setWorkLevel, workLevel)}
    className="form-control"
    style={{
      overflow: 'hidden',
      height: '1vh', // Alkuperäinen korkeus
      marginBottom: "1vh"
    }}
  />
</div>

<div className="form-group">
  <label>{tyoskentelynPainoarvo}</label>
  <textarea
    value={workFocus}
    onChange={(e) => {
      setWorkFocus(e.target.value);
      e.target.style.height = "auto";
      e.target.style.height = e.target.value.trim() !== "" ? `${e.target.scrollHeight}px` : '1vh';
    }}
    onKeyDown={(e) => handleKeyDown(e, setWorkFocus, workFocus)}
    className="form-control"
    style={{
      overflow: 'hidden',
      height: '1vh', // Alkuperäinen korkeus
      marginBottom: "1vh"
    }}
  />
</div>

<div className="form-group" style={{ marginTop: "5vh" }}>
  <label>{sectionTitles.culture}</label>
</div>

<div className="form-group">
  <label>{tyoryhma}</label>
  <textarea
    value={teamDescription}
    onChange={(e) => {
      setTeamDescription(e.target.value);
      e.target.style.height = "auto";
      e.target.style.height = e.target.value.trim() !== "" ? `${e.target.scrollHeight}px` : '1vh';
    }}
    onKeyDown={(e) => handleKeyDown(e, setTeamDescription, teamDescription)}
    className="form-control"
    style={{
      overflow: 'hidden',
      height: '1vh', // Alkuperäinen korkeus
      marginBottom: "1vh"
    }}
  />
</div>

<div className="form-group">
  <label>{toimintakulttuuri}</label>
  <textarea
    value={cultureTraits}
    onChange={(e) => {
      setCultureTraits(e.target.value);
      e.target.style.height = "auto";
      e.target.style.height = e.target.value.trim() !== "" ? `${e.target.scrollHeight}px` : '1vh';
    }}
    onKeyDown={(e) => handleKeyDown(e, setCultureTraits, cultureTraits)}
    className="form-control"
    style={{
      overflow: 'hidden',
      height: '1vh', // Alkuperäinen korkeus
      marginBottom: "1vh"
    }}
  />
</div>

<div className="form-group">
  <label>{johtamiskaytannot}</label>
  <textarea
    value={leadershipStyle}
    onChange={(e) => {
      setLeadershipStyle(e.target.value);
      e.target.style.height = "auto";
      e.target.style.height = e.target.value.trim() !== "" ? `${e.target.scrollHeight}px` : '1vh';
    }}
    onKeyDown={(e) => handleKeyDown(e, setLeadershipStyle, leadershipStyle)}
    className="form-control"
    style={{
      overflow: 'hidden',
      height: '1vh', // Alkuperäinen korkeus
      marginBottom: "1vh"
    }}
  />
</div>

<div className="form-group">
  <label>{arvot}</label>
  <textarea
    value={companyValues}
    onChange={(e) => {
      setCompanyValues(e.target.value);
      e.target.style.height = "auto";
      e.target.style.height = e.target.value.trim() !== "" ? `${e.target.scrollHeight}px` : '1vh';
    }}
    onKeyDown={(e) => handleKeyDown(e, setCompanyValues, companyValues)}
    className="form-control"
    style={{
      overflow: 'hidden',
      height: '1vh', // Alkuperäinen korkeus
      marginBottom: "1vh"
    }}
  />
</div>

<div className="form-group">
  <label>{sectionTitles.appeal}</label>
  <label>{motivaatiotekijat}</label>
</div>

<div className="form-group">
  <label>{organisaatio}</label>
  <textarea
    value={organizationAppeal}
    onChange={(e) => {
      setOrganizationAppeal(e.target.value);
      e.target.style.height = "auto";
      e.target.style.height = e.target.value.trim() !== "" ? `${e.target.scrollHeight}px` : '1vh';
    }}
    onKeyDown={(e) => handleKeyDown(e, setOrganizationAppeal, organizationAppeal)}
    className="form-control"
    style={{
      overflow: 'hidden',
      height: '1vh', // Alkuperäinen korkeus
      marginBottom: "1vh"
    }}
  />
</div>

<div className="form-group">
  <label>{tyo}</label>
  <textarea
    value={jobAppeal}
    onChange={(e) => {
      setJobAppeal(e.target.value);
      e.target.style.height = "auto";
      e.target.style.height = e.target.value.trim() !== "" ? `${e.target.scrollHeight}px` : '1vh';
    }}
    onKeyDown={(e) => handleKeyDown(e, setJobAppeal, jobAppeal)}
    className="form-control"
    style={{
      overflow: 'hidden',
      height: '1vh', // Alkuperäinen korkeus
      marginBottom: "1vh"
    }}
  />
</div>

<div className="form-group">
  <label>{kuukausiansiot}</label>
  <textarea
    value={salaryAndIncentives}
    onChange={(e) => {
      setSalaryAndIncentives(e.target.value);
      e.target.style.height = "auto";
      e.target.style.height = e.target.value.trim() !== "" ? `${e.target.scrollHeight}px` : '1vh';
    }}
    onKeyDown={(e) => handleKeyDown(e, setSalaryAndIncentives, salaryAndIncentives)}
    className="form-control"
    style={{
      overflow: 'hidden',
      height: '1vh', // Alkuperäinen korkeus
      marginBottom: "1vh"
    }}
  />
</div>

<div className="form-group">
  <label>{ihmiset}</label>
  <textarea
    value={peopleAppeal}
    onChange={(e) => {
      setPeopleAppeal(e.target.value);
      e.target.style.height = "auto";
      e.target.style.height = e.target.value.trim() !== "" ? `${e.target.scrollHeight}px` : '1vh';
    }}
    onKeyDown={(e) => handleKeyDown(e, setPeopleAppeal, peopleAppeal)}
    className="form-control"
    style={{
      overflow: 'hidden',
      height: '1vh', // Alkuperäinen korkeus
      marginBottom: "1vh"
    }}
  />
</div>

<div className="form-group">
  <label>{mahdollisuudet}</label>
  <textarea
    value={growthOpportunities}
    onChange={(e) => {
      setGrowthOpportunities(e.target.value);
      e.target.style.height = "auto";
      e.target.style.height = e.target.value.trim() !== "" ? `${e.target.scrollHeight}px` : '1vh';
    }}
    onKeyDown={(e) => handleKeyDown(e, setGrowthOpportunities, growthOpportunities)}
    className="form-control"
    style={{
      overflow: 'hidden',
      height: '1vh', // Alkuperäinen korkeus
      marginBottom: "1vh"
    }}
  />
</div>

<div className="form-group">
  <label>{sisaisetHakijat}</label>
  <textarea
    value={internalCandidates}
    onChange={(e) => {
      setInternalCandidates(e.target.value);
      e.target.style.height = "auto";
      e.target.style.height = e.target.value.trim() !== "" ? `${e.target.scrollHeight}px` : '1vh';
    }}
    onKeyDown={(e) => handleKeyDown(e, setInternalCandidates, internalCandidates)}
    className="form-control"
    style={{
      overflow: 'hidden',
      height: '1vh', // Alkuperäinen korkeus
      marginBottom: "1vh"
    }}
  />
</div>

<div className="form-group">
  <label>{ulkopuolisetHakijat}</label>
  <textarea
    value={externalCandidates}
    onChange={(e) => {
      setExternalCandidates(e.target.value);
      e.target.style.height = "auto";
      e.target.style.height = e.target.value.trim() !== "" ? `${e.target.scrollHeight}px` : '1vh';
    }}
    onKeyDown={(e) => handleKeyDown(e, setExternalCandidates, externalCandidates)}
    className="form-control"
    style={{
      overflow: 'hidden',
      height: '1vh', // Alkuperäinen korkeus
      marginBottom: "1vh"
    }}
  />
</div>

<div className="form-group">
  <label>{kilpailijat}</label>
  <textarea
    value={competitors}
    onChange={(e) => {
      setCompetitors(e.target.value);
      e.target.style.height = "auto";
      e.target.style.height = e.target.value.trim() !== "" ? `${e.target.scrollHeight}px` : '1vh';
    }}
    onKeyDown={(e) => handleKeyDown(e, setCompetitors, competitors)}
    className="form-control"
    style={{
      overflow: 'hidden',
      height: '1vh', // Alkuperäinen korkeus
      marginBottom: "1vh"
    }}
  />
</div>

<div className="form-group">
  <label>{kielletytTahot}</label>
  <textarea
    value={prohibitedContacts}
    onChange={(e) => {
      setProhibitedContacts(e.target.value);
      e.target.style.height = "auto";
      e.target.style.height = e.target.value.trim() !== "" ? `${e.target.scrollHeight}px` : '1vh';
    }}
    onKeyDown={(e) => handleKeyDown(e, setProhibitedContacts, prohibitedContacts)}
    className="form-control"
    style={{
      overflow: 'hidden',
      height: '1vh', // Alkuperäinen korkeus
      marginBottom: "1vh"
    }}
  />
</div>

<div className="form-group">
  <label>{finaalihaastattelijat}</label>
  <textarea
    value={finalInterviewParticipants}
    onChange={(e) => {
      setFinalInterviewParticipants(e.target.value);
      e.target.style.height = "auto";
      e.target.style.height = e.target.value.trim() !== "" ? `${e.target.scrollHeight}px` : '1vh';
    }}
    onKeyDown={(e) => handleKeyDown(e, setFinalInterviewParticipants, finalInterviewParticipants)}
    className="form-control"
    style={{
      overflow: 'hidden',
      height: '1vh', // Alkuperäinen korkeus
      marginBottom: "1vh"
    }}
  />
</div>

<div className="form-group">
  <label>{alustavaFinaalihaastatteluPäivä}</label>
  <input
    type="date"
    value={finalInterviewDate}
    onChange={(e) => setFinalInterviewDate(e.target.value)}
  />
</div>

<div className="form-group">
  <label>{top5Kriteerit}</label>
  <textarea
    value={top5Criteria}
    onChange={(e) => {setTop5Criteria(e.target.value); 
    e.target.style.height = "auto";
    e.target.style.height = e.target.value.trim() !== "" ? `${e.target.scrollHeight}px` : '1vh';
  }}
    onKeyDown={(e) => handleKeyDown(e, setTop5Criteria, top5Criteria)}
    style={{
      overflow: 'hidden',
      height: '1vh', 
      marginBottom: "1vh"
    }}
  />
</div>
<div style={{ display: 'flex', justifyContent: 'center' }}>
    <Button
          className="SignIn"
          variant="primary"
          type="button"
          style={{ flexGrow: 1, maxWidth: "200px", marginLeft: "1%" }}
          onClick={openModal} // Avaa vahvistusmodaali
        >
          {buttons.submit}
        </Button>
</div>
</div>
 )}
  {/* Toinen lomake */}
{activeTab === 'form2' && (
        <div>
          <h2>{openProfileTitle}</h2>
          <div className="form-group">
          <div className="form-group">
        <label>{yritys}</label>
        <input
          type="text"
          value={company}
          onChange={(e) => setCompany(e.target.value)}
        />
      </div>

      <div className="form-group">
        <label>{yhteyshenkilo}</label>
        <input
          type="text"
          value={contactPerson}
          onChange={(e) => setContactPerson(e.target.value)}
        />
      </div>

      <div className="form-group">
        <label>{currentTranslation.labels.consultant}</label>
        <select value={valittuKonsultti} onChange={(e) => setValittuKonsultti(e.target.value)}>
          <option value="">{latausKaynnissa ? notices.loading : currentTranslation.labels.consultantPlaceholder}</option>
          {!latausKaynnissa && konsultit.map((konsultti, index) => (
            <option key={index} value={konsultti}>{konsultti}</option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label>{currentTranslation.labels.interviewLanguage}</label>
        <select value={valittuKieli} onChange={(e) => setValittuKieli(e.target.value)}>
          <option value="">{currentTranslation.labels.interviewLanguagePlaceholder}</option>
          { kielet.map((kieli, index) => (
            <option key={index} value={kieli}>{kieli}</option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label>{haettavaTehtava}</label>
        <input
          type="text"
          value={jobTitle}
          onChange={(e) => setJobTitle(e.target.value)}
        />
      </div>

      <div className="form-group">
        <label>{toimiala}</label>
        <input
          type="text"
          value={industry}
          onChange={(e) => setIndustry(e.target.value)}
        />
      <div className="form-group">
      <label>{top5Kriteerit}</label>
        <textarea
          value={top5Criteria}
          onChange={(e) => {setTop5Criteria(e.target.value); 
          e.target.style.height = "auto";
          e.target.style.height = e.target.value.trim() !== "" ? `${e.target.scrollHeight}px` : '1vh';
        }}
          onKeyDown={(e) => handleKeyDown(e, setTop5Criteria, top5Criteria)}
          style={{
            overflow: 'hidden',
            height: '1vh', 
            marginBottom: "1vh"
          }}
        />
</div>

      </div>
            <label>{jobDescriptionLabel}</label>
            <textarea

              value={avoin}
              placeholder={jobDescriptionPlaceholder}
              onChange={(e) => {
                setAvoin(e.target.value);
                e.target.style.height = "auto"; // Poistaa edellisen korkeusasetuksen
                e.target.style.height = e.target.value.trim() !== "" ? `${e.target.scrollHeight}px` : '10vh'; // Asettaa korkeuden syötteen mukaan
              }}
              style={{
                overflow: 'hidden',
                height: '10vh', // Aluksi kenttä on isompi
                marginBottom: "1vh",
              }}
            />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
    <Button
          className="SignIn"
          variant="primary"
          type="button"
          style={{ flexGrow: 1, maxWidth: "200px", marginLeft: "1%" }}
          onClick={openModal} // Avaa vahvistusmodaali
        >
          {buttons.submit}
        </Button>
</div>
        </div>
      )}
{/* Vahvistusmodaali */}
<Modal
  isOpen={isModalOpen}
  onRequestClose={closeModal}
  contentLabel={notices.confirmationTitle}
  style={{
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width: '30vw',
      height: '60vh',
      maxWidth: '90vw',
      maxHeight: '80vh',
      padding: '20px',
      textAlign: "center",
    }
  }}
>
  {isSending && !ready ? (
    <div style={{ textAlign: "center" }}>
      <img className="logopikku" src={Logopikku} alt="kuva" />
      <div>
        <p>{notices.loading}</p>
      </div>
    </div>
  ) : ready ? (
    <div style={{ textAlign: "center" }}>
      <h2>{notices.readyTitle}</h2>
      <p>{notices.readyBody}</p>
      <p>{notices.readyNote}</p>
      <Button variant="primary" style={{ marginTop: "2vh" }} onClick={() => {
        closeModal();
        navigate("/dashboard");
      }}>
        {buttons.close}
      </Button>
    </div>
  ) : (
    // Tarkista, onko virheitä ja näytä ne modalissa
    Object.keys(formErrors).length > 0 ? (
      <>
        <h2>{notices.attention}</h2>
        <ul style={{ color: "red", listStyle: "none", padding: 0 }}>
          {Object.entries(formErrors).map(([field, error]) => (
            <li key={field}>{error}</li>
          ))}
        </ul>
        <Button variant="danger" onClick={closeModal}>{buttons.close}</Button>
      </>
    ) : (
      <>
        <h2>{notices.confirmationTitle}</h2>
        <p>{notices.confirmationQuestion}</p>
        <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '5vh', marginBottom: '5vh' }}>
          {submitError && <p role="alert" className="text-danger">{submitError}</p>}
          <Button variant="success" onClick={confirmSubmit} disabled={isSending}>{buttons.submit}</Button>
          <Button variant="danger" onClick={closeModal}>{buttons.cancel}</Button>
        </div>
      </>
    )
  )}
  
</Modal>

    </div>
  );
}

export default Mandaatti;
/*
<div className="form-group">
        <label>{alustavaFinaalihaastatteluPäivä}</label>
        <input
          type="date"
          value={finalInterviewDate}
          onChange={(e) => setFinalInterviewDate(e.target.value)}
        />
      </div>


*/
